import axios from 'axios'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { NavLink, Navigate } from 'react-router-dom'
import SearchComponent from '../../../../Search'
import { Helmet } from 'react-helmet'
import Swal from 'sweetalert2'
const StaffAccount = (props) => {
    const user = props.user
    const [UserList, setUserList] = useState([])
    // APIs
    const loadUsers = async() => {
        const config = {
            headers: {
                'Content-Type' : 'application/json',
                'Accept' : 'application/json',
                'Authorization' : `JWT ${localStorage.getItem('access')}`
            }
        }
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/user/staff/list/`, config)
            setUserList(response?.data?.users)
        } catch (error) {
        // console.log('first', error)
        //   setResponseError(error.response.statusText)
        }
    }
    const deleteUsers = async(id) => {
        const config = {
            headers: {
                'Content-Type' : 'application/json',
                'Accept' : 'application/json',
                'Authorization' : `JWT ${localStorage.getItem('access')}`
            }
        }
        const Body = JSON.stringify({
            userId : id
        })
        try {
            await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/user/staff/delete/`, Body, config)
            loadUsers()
            Swal.fire({
                position: "bottom-end",
                type: "error",
                title: "Success",
                html: `User Deleted.`,
                showConfirmButton: !1,
                timer: 1500,
                confirmButtonClass: "btn btn-primary",
                buttonsStyling: !1,
            })
        } catch (error) {
        // console.log('first', error)
        //   setResponseError(error.response.statusText)
            Swal.fire({
                position: "bottom-end",
                type: "error",
                title: "Error",
                html: `Something went wrong.`,
                showConfirmButton: !1,
                timer: 1500,
                confirmButtonClass: "btn btn-primary",
                buttonsStyling: !1,
            })
        }
    }
    useEffect(() => {
        loadUsers()
    }, [])
    
    if (!user?.is_superuser) {
        return <Navigate to="/"/> 
    }
    return (
        <div className='content'>
            <Helmet>
                <title>
                    Staff Accounts - CI Mart
                </title>
            </Helmet>
            <div className="page-header">
                <div className="page-title">
                    <h4>Staff Accounts Management</h4>
                    <h6>You can add upto {user?.total_stores} staff accounts</h6>
                </div>
            </div>
            <hr/>
            <div className="card mb-0">
                <div className="card-body">
                    <div className="card-header pb-0 d-flex justify-content-between align-items-center">
                        <h4 className="card-title">Staff User List</h4>
                        <div className="graph-sets">
                            {
                                user?.total_stores > UserList.length ?   
                                    <div className='px-1 w-100'>
                                        <NavLink to="/admin/users/staff/add" className='btn btn-primary'>Add Staff Account</NavLink>
                                    </div>
                                : <></>
                            }
                        </div>
                    </div>
                    
                    <div className="table-responsive text-wrap">
                        <table className="table mb-0">
                            <thead>
                                
                                <tr>
                                    <th>
                                        Name 
                                    </th>
                                    <th >
                                        Email
                                    </th>
                                    <th>
                                        Store
                                    </th>
                                    <th>
                                        Status                                    
                                    </th>
                                    <th>
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    UserList.map(
                                        (row, index)=>{
                                        return(
                                            <>
                                            <tr key={index}>
                                                <td>
                                                    {row?.first_name + " " + row?.last_name}
                                                </td>
                                                <td>
                                                    {row?.email}
                                                </td>
                                                <td>
                                                    {row?.store_name}
                                                </td>
                                                <td>
                                                    {
                                                        row?.is_active ?
                                                        <span >
                                                            Active
                                                        </span>
                                                        : <>Not Active</>
                                                    }
                                                </td>
                                                <td>
                                                    <NavLink 
                                                        to={{pathname:"/admin/users/staff/edit"}} 
                                                        state={
                                                            {
                                                                account : row?.userId
                                                            }
                                                        } 
                                                        className="me-3" >
                                                        <img src="../../assets/img/icons/edit.svg" alt="img"/>
                                                    </NavLink>
                                                    <a 
                                                        onClick={(e)=>{deleteUsers(row?.id)}}
                                                        className="me-3" >
                                                        <img src="../../assets/img/icons/delete.svg" alt="img"/>
                                                    </a>
                                                </td>
                                            </tr>
                                            </>
                                        )
                                        })
                                    }
                            </tbody>
                        </table>
                        <br/>
                        <div className='pagination justify-content-center'>
                            
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

const mapStateToProps = (state) => ({
	isAuthenticated: state.Auth.isAuthenticated,
	user: state.Auth.user
})
  
export default connect(mapStateToProps)(StaffAccount)